<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.vendorStockStatus') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.totalStockValue') }}</label>
          <div class="value">¥{{ detail.totalValueOnSellImPriceDay||'-' }}（{{$t('crm.level',[detail.onSellValueRank||''])}}）
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.dailyNewStock') }}</label>
          <div class="value">¥{{ detail.avgValuePushNewImPrice30Day||'-' }}（{{$t('crm.level',[detail.avgValuePushNew30DayRank||''])}}）</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.soltOutRank') }}</label>
          <div class="value">{{ detail.sellOutRateMonth||'-' }}（{{$t('crm.level',[detail.sellOutRateMonthRank||''])}}）</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.newStockFre') }}</label>
          <div class="value">{{ detail.pushNewQty30Day || '-' }}</div>
        </div>
        <div class="info-item">
          <label>IM业务类型</label>
          <div class="value">{{ formAdd.imType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>供应商类型</label>
          <div class="value">{{ formAdd.supplierType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>商品品相</label>
          <div class="value">{{ formAdd.productType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>商品获取方式</label>
          <div class="value">{{ formAdd.fromType || '-' }}</div>
        </div>
      </div>
      <div class="a">
      </div>
    </el-card>

    <div class="table-container">
      <table border="1" style='margin:20'>
        <tbody>
          <tr class="header">
            <th :rowspan="allGoods.length+2" style="width:120px">
              <p>0-7级货品情况</p>
              <span>（全部商品）</span>
            </th>
            <th colspan="5">品类</th>
          </tr>
          <template v-for="(item,index) in allGoods ">
            <tr class="body" v-if="index===0">
              <th></th>
              <th class="body-bg" v-for="son in item">{{son.spuCategoryLevel2Name}}</th>
            </tr>
            <tr class="body">
              <th>{{allGoods.length-index-1}}</th>
              <th v-for="son in item">{{son.productQtyRete||0}}</th>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <table border="1" style='margin:20'>
        <tbody>
          <tr class="header">
            <th :rowspan="onsaleGoods.length+2" style="width:120px">
              <p>0-7级货品情况</p>
              <span>（在售商品）</span>
            </th>
            <th colspan="5">品类</th>
          </tr>
          <template v-for="(item,index) in onsaleGoods ">
            <tr class="body" v-if="index===0">
              <th></th>
              <th class="body-bg" v-for="son in item">{{son.spuCategoryLevel2Name}}</th>
            </tr>
            <tr class="body">
              <th>{{onsaleGoods.length-index-1}}</th>
              <th v-for="son in item">{{son.productOnSellQtyRete||0}}</th>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="canvas-container">
      <div class="chart" ref="chartA"></div>
      <div class="chart" ref="chartB"></div>
    </div>
  </div>
</template>

<script>
import { productInfo, productGoodsAll, productGoodsOnsale, productPushNew, productOldValue, getVendorInfo } from '../api';
import * as echarts from "echarts";
export default {
  data() {
    return {
      detail: {},
      allGoods: [],
      onsaleGoods: [],
      formAdd: {}
    };
  },
  methods: {
    getVendorInfo(){
      getVendorInfo({vendorId:this.$route.params.id}).then(res =>{
        var formAdd ={};
        res.data.data.map(item => {
          if (item.infoType == 5){
            formAdd.imType = item.data
          }else if (item.infoType == 6){
            formAdd.supplierType = item.data
          }else if (item.infoType == 7){
            formAdd.productType = item.data
          }else if (item.infoType == 8){
            formAdd.fromType = item.data
          }
        })
        this.$nextTick(()=>{
          this.formAdd = {
            ...formAdd
          }
        })
      })
    },
    groupBy(objectArray, property) {
      return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
    },
    getMaxLength(arr) {
      if (!arr.length) return 0
      var max = arr[0].length;
      var b = 0;
      for (let index = 1; index < arr.length; index++) {
        const element = arr[index];
        if (max < element.length) {
          max = element.length;
          b = index;
        }
      }
      return arr[b].length;
    },
    async productInfo() {
      this.$store.commit("setPageLoading", true);
      try {
        const res = (await productInfo(this.$route.params.id)).data;
        this.detail = this.formatDetal(res);
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$store.commit("setPageLoading", false);
        this.$message.error(`${error}`)
      }
      this.$store.commit("setPageLoading", false);
    },
    formatDetal(res) {
      return {
        ...res,
        totalValueOnSellImPriceDay: this.format_with_regex((res.totalValueOnSellImPriceDay || 0).toFixed(0)),
        avgValuePushNewImPrice30Day: this.format_with_regex((res.avgValuePushNewImPrice30Day || 0).toFixed(0))
      }
    },
    format_with_regex(number) {
      var reg = /(\d)(?=(?:\d{3})+$)/g
      return (number + '').replace(reg, '$1,');
    },
    async productGoodsAll() {
      this.$store.commit("setPageLoading", true);
      try {
        const res = (await productGoodsAll(this.$route.params.id)).data;
        const goodsLayersBrandCodeList = Object.values(this.groupBy(res, 'goodsLayersBrandCode')).reverse();
        const MAX_LENTH = this.getMaxLength(goodsLayersBrandCodeList)
        this.allGoods = (goodsLayersBrandCodeList || []).map(item => {
          if (item.length < MAX_LENTH) {
            return item.concat(Array(MAX_LENTH - item.length).fill({}))
          }
          return item
        });
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("setPageLoading", false);
        this.$message.error(`${error}`)
      }
      this.$store.commit("setPageLoading", false);
    },
    async productGoodsOnsale() {
      this.$store.commit("setPageLoading", true);
      try {
        const res = (await productGoodsOnsale(this.$route.params.id)).data;
        const goodsLayersBrandCodeList = Object.values(this.groupBy(res, 'goodsLayersBrandCode')).reverse();
        const MAX_LENTH = this.getMaxLength(goodsLayersBrandCodeList)
        this.onsaleGoods = (goodsLayersBrandCodeList || []).map(item => {
          if (item.length < MAX_LENTH) {
            return item.concat(Array(MAX_LENTH - item.length).fill({}))
          }
          return item
        });
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$store.commit("setPageLoading", false);
        this.$message.error(`${error}`)
      }
      this.$store.commit("setPageLoading", false);
    },
    async productPushNew() {
      this.$store.commit("setPageLoading", true);
      try {
        const res = (await productPushNew(this.$route.params.id)).data;
        this.getChartDataA(res || []);
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$store.commit("setPageLoading", false);
      }
      this.$store.commit("setPageLoading", false);
    },
    async productOldValue() {
      this.$store.commit("setPageLoading", true);
      try {
        const res = (await productOldValue(this.$route.params.id)).data;
        this.getChartDataB(res || []);
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$store.commit("setPageLoading", false);
        this.$message.error(`${error}`)
      }
    },
    getChartDataA(data = []) {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chartA);
        const xAxis = data.map(item => {
          return `${item.yearCode}-${item.totalWeekSeq}(${item.dayBegin.slice(-4)}-${item.dayEnd.slice(-4)})`
        })
        const avgValuePushImPriceDay = data.map(item => {//avgValuePushImPriceDay
          return item.avgValuePushImPriceDay || 0
        });
        const avgPushGoodsGmvDay = data.map(item => {//日均推货gmv
          return item.avgPushGoodsGmvDay || 0
        });
        const avgPushSoldoutRate = data.map(item => { //日均推货售罄率
          return item.avgPushSoldoutRate || 0
        });
        this.chart.setOption({
          color: ['#91cc75', '#fc8452'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          legend: {
            left: 'center',
            top: 'bottom',
            data: ['日均推货货值', '日均推货gmv']
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '日均推货货值',
              axisLabel: {
                formatter: function (value) {
                  if (value >= 10000) {
                    return value / 10000 + "万";
                  } else {
                    return value;
                  }
                },
              }
            },
            {
              type: 'value',
              name: '日均推货gmv',
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          series: [
            {
              name: '日均推货货值',
              type: 'bar',
              data: avgValuePushImPriceDay
            },
            {
              name: '日均推货gmv',
              type: 'line',
              yAxisIndex: 1,
              data: avgPushGoodsGmvDay
            }
          ]
        })
      }
    },
    getChartDataB(data = []) {
      if (!this.chartB) {
        this.chartB = echarts.init(this.$refs.chartB);
        const xAxis = data.map(item => {
          return `${item.yearCode}-${item.totalWeekSeq}(${item.dayBegin.slice(-4)}-${item.dayEnd.slice(-4)})`
        })
        const avgValueOldImPriceDay = data.map(item => {
          return item.avgValueOldImPriceDay || ''
        });
        const avgOldGoodsGmvDay = data.map(item => {
          return item.avgOldGoodsGmvDay || ''
        });
        const avgOldSoldoutRate = data.map(item => {
          return item.avgOldSoldoutRate || ''
        });
        this.chartB.setOption({
          color: ['#91cc75', '#fc8452'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          legend: {
            left: 'center',
            top: 'bottom',
            data: ['日均存货货值', '日均存货gmv']
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '日均存货货值',
              axisLabel: {
                formatter: function (value) {
                  if (value >= 10000) {
                    return value / 10000 + "万";
                  } else {
                    return value;
                  }
                },
              }
            },
            {
              type: 'value',
              name: '日均存货gmv',
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          series: [
            {
              name: '日均存货货值',
              type: 'bar',
              data: avgValueOldImPriceDay
            },
            {
              name: '日均存货gmv',
              type: 'line',
              yAxisIndex: 1,
              data: avgOldGoodsGmvDay
            }
          ]
        })
      }
    },
  },
  mounted() {
    this.productInfo()
    this.productGoodsAll()
    this.productGoodsOnsale()
    this.productPushNew()
    this.productOldValue()
    this.getVendorInfo()
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ebeef5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n + 3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
.table-container {
  width: 100%;
  padding: 20px;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #ebeef5;
  th {
    padding: 10px 0;
  }
  .header {
    th {
      background: #dcdfe6;
    }
  }
  .body {
    th:nth-child(1),
    .body-bg {
      background: #f2f6fc;
    }
  }
}
.chart {
  width: 774px;
  margin-top: 20px;
  height: 400px;
}
.canvas-container {
  display: flex;
  justify-content: space-between;
}
</style>
